import React, { FC, useRef } from "react";
import { A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../image";
import type { CentralBanksOpenDomesticPaymentsProps } from "@/types";
import { TextCols } from "../text-cols";
import { useInView } from "@/hooks/reveal-in-view";

export const CentralBanksOpenDomesticPayments: FC<
  CentralBanksOpenDomesticPaymentsProps
> = ({ content, gallery }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="centralBanksOpenDomesticPayments">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={760} />
      </div>
      <div className="wrapper wrapper_lg" ref={ref}>
        <Swiper
          modules={[A11y]}
          spaceBetween={12}
          slidesPerView={1.25}
          breakpoints={{
            1024: {
              slidesPerView: 2,
              spaceBetween: 56,
            },
          }}
          grabCursor
          className="centralBanksOpenDomesticPayments--swiper"
        >
          {gallery.map((slide, index) => {
            return (
              <SwiperSlide
                key={index}
                className="centralBanksOpenDomesticPayments--slide"
                style={{
                  transform: isInView
                    ? 'none'
                    : `translateY(${20 * (index + 1)}px)`,
                  opacity: isInView ? 1 : 0,
                  transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                    index * 0.1
                  }s`,
                }}
              >
                {slide.file?.url && (
                  <Image
                    className="centralBanksOpenDomesticPayments--slide-image"
                    src={slide as any}
                    alt={slide.title}
                    draggable={false}
                    options={{
                      sizes: {
                        exec: [
                          {
                            width: 692,
                            height: 682,
                          },
                        ],
                      },
                    }}
                  />
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};
